export enum SequenceTypeEnum {
  PRZEJSCIE_WARUNKOWE = 'PRZEJSCIE_WARUNKOWE',
  SKARBIEC = 'SKARBIEC',
}

export enum SequenceTypeDescriptionEnum {
  SKARBIEC = 'sequences.type.vault',
  PRZEJSCIE_WARUNKOWE = 'sequences.type.passageway',
}
